import React, { useCallback, useEffect, useState } from "react";
import icon from "../../images/Icons/rfq.png";
import { useParams } from "react-router";
import axios from "axios";
import config from "../../config";
import NumberFormatter from "../../Component/NumberFormatter";
import useLogout from "../Auth/useLogout";
import NoData from "../../Component/NoData";
import Dataloader from "../../Component/Dataloader";
import { Link } from "react-router-dom";

export default function QuotationDetail() {
  const params = useParams();
  const logout = useLogout();
  const [loading, setLoading] = useState(false);
  const [exist, setExist] = useState(true);
  const [data, setData] = useState({
    product: {
      unique_id: "",
      category: "",
      product: "",
      brand: "",
      order_id: null,
      purpose: "",
      message: "",
    },
    billing: [],
    consignee: [],
    variation: [],
    status: "",
    orderData: {
      base_price: "",
      freight: "",
      total_quantity: "",
      total_ex_price: "",
      total_freight: "",
      total_payable_amount: "",
      order_amount: "",
      purpose: "",
      message: "",
    },
    credit_days: 0,
    packaging_charge: null,
    quality: null,
    commission_type: "",
    commission: "",
    load_within: "",
    token_amount: 0,
  });

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${config.apiUrl}/product-enquiry/${params.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        }
      );    

      setData((prevData) => ({
        ...prevData,
        product: {
          unique_id: response.data.data.unique_id,
          category: response.data.data.commodity_product.category.name,
          product: response.data.data.commodity_product.name,
          brand: response.data.data.brand.name,
          order_id: response.data.data.order_id,
          purpose: response.data.data.purpose,
          message: response.data.data.description,
        },
        billing: response.data.data.billing_address,
        consignee: response.data.data.consignee_detail,
        variation: response.data.data.variation,
        status: response.data.data.status,
        orderData: {
          base_price: response.data.data.base_price,
          freight: response.data.data.transport_price,
          total_quantity: response.data.data.total_quantity,
          total_freight:
            +response.data.data.total_quantity *
            +response.data.data.transport_price,
          total_ex_price: response.data.data.ex_price,
          total_payable_amount: response.data.data.for_price,
          order_amount: response.data.data.required_booking_amount,
        },
        credit_days: response.data.data.credit_days,
        packaging_charge: response.data.data.selected_packaging_charge,
        quality: response.data.data.selected_quality,
        commission_type: response.data.data.commission_type,
        commission: response.data.data.commission,
        load_within: response.data.data.load_within,
        token_amount: response.data.data.token_amount,
      }));
    } catch (error) {
      if (
        error.response &&
        (error.response.status === 404 ||
          error.response.status === 400 ||
          error.response.status === 500)
      ) {
        setExist(false);
      }
      if (error.response && error.response.status === 401) {
        logout();
      }
    } finally {
      setLoading(false);
    }
  }, [logout, params.id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row-layout mrb1">
          {loading ? (
            <div className="d-flex justify-content-center">
              <Dataloader />
            </div>
          ) : (
            <>
              {exist ? (
                <>
                  <div className="row-hd-txt">
                    <div className="row-hd-txt-left">
                      <img src={icon} alt="icon" />
                      <h5>Quotation Details</h5>
                    </div>
                    <div className="status-right">
                      <h6 className="status sent">{data.status}</h6>
                    </div>
                  </div>
                  <div className="row g-3 purchase-order-row">
                    <div className="col-lg-4 px-2">
                      <div className="purchase-order-table">
                        <label className="order-label">Product Details</label>
                        <table className="table chart-table table-bordered m-0">
                          <tbody>
                            <tr>
                              <td>Quotation No:</td>
                              <td>{data.product.unique_id}</td>
                            </tr>
                            <tr>
                              <td>Category:</td>
                              <td>{data.product.category}</td>
                            </tr>
                            <tr>
                              <td>Brand:</td>
                              <td>{data.product.brand}</td>
                            </tr>
                            <tr>
                              <td>Product:</td>
                              <td>{data.product.product}</td>
                            </tr>
                            <tr>
                              <td>Requirement:</td>
                              <td>
                                {data.variation?.map((item) => (
                                  <span key={item.id}>
                                    {item.value[0].value}
                                    {item.value[0].unit.short_name}
                                    {" - "}
                                    {item.quantity}MT{", "}
                                  </span>
                                ))}
                              </td>
                            </tr>
                            {data.quality && (
                              <tr>
                                <td>Quality:</td>
                                <td>{data.quality.name}</td>
                              </tr>
                            )}
                            {data.packaging_charge && (
                              <tr>
                                <td>Packaging:</td>
                                <td>
                                  {data.packaging_charge.name}
                                </td>
                              </tr>
                            )}
                            <tr>
                              <td>Purpose:</td>
                              <td>{data.product.purpose}</td>
                            </tr>
                            <tr>
                              <td>Message:</td>
                              <td>{data.product.message}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 px-2">
                      <div className="purchase-order-table">
                        <label className="order-label">Buyer(Bill To)</label>
                        <table className="table chart-table table-bordered m-0">
                          <tbody>
                            <tr>
                              <td>Company Name:</td>
                              <td>{data.billing.company_name}</td>
                            </tr>
                            <tr>
                              <td>Phone Number:</td>
                              <td>{data.billing.phone}</td>
                            </tr>
                            <tr>
                              <td>GST:</td>
                              <td>{data.billing.gst}</td>
                            </tr>
                            <tr>
                              <td>Address Line1:</td>
                              <td>{data.billing.address_line_one}</td>
                            </tr>
                            <tr>
                              <td>Address Line2:</td>
                              <td>{data.billing.address_line_two}</td>
                            </tr>
                            <tr>
                              <td>City:</td>
                              <td>{data.billing.city}</td>
                            </tr>
                            <tr>
                              <td>State:</td>
                              <td>{data.billing.state}</td>
                            </tr>
                            <tr>
                              <td>Pincode:</td>
                              <td>{data.billing.pincode ?? data.billing.pin_code}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 px-2">
                      <div className="purchase-order-table">
                        <label className="order-label">
                          Consignee(Ship To)
                        </label>
                        <table className="table chart-table table-bordered m-0">
                          <tbody>
                            <tr>
                              <td>Company Name:</td>
                              <td>{data.consignee.company_name}</td>
                            </tr>
                            <tr>
                              <td>Phone Number:</td>
                              <td>{data.consignee.phone}</td>
                            </tr>
                            <tr>
                              <td>GST:</td>
                              <td>{data.consignee.gst}</td>
                            </tr>
                            <tr>
                              <td>Address Line1:</td>
                              <td>{data.consignee.address_line_one}</td>
                            </tr>
                            <tr>
                              <td>Address Line2:</td>
                              <td>{data.consignee.address_line_two}</td>
                            </tr>
                            <tr>
                              <td>City:</td>
                              <td>{data.consignee.city}</td>
                            </tr>
                            <tr>
                              <td>State:</td>
                              <td>{data.consignee.state}</td>
                            </tr>
                            <tr>
                              <td>Pincode:</td>
                              <td>{data.consignee.pincode ?? data.consignee.pin_code}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {(data.status === "ordered" ||
                      data.status === "Seller Marked" || data.status === "Transporter Replied") && (
                        <>
                          <div className="col-lg-6 px-2">
                            <div className="purchase-order-table card-shadow bg-primary-gradient ">
                              <label className="order-label">
                                Order Details
                              </label>
                              <table>
                                <tbody>
                                  <tr>
                                    <td>Basic Price:</td>
                                    <td className="text-success animate-price fs-4">
                                      Rs{" "}
                                      <NumberFormatter number={data.orderData.base_price} />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Total Quantity:</td>
                                    <td>{data.orderData.total_quantity}MT</td>
                                  </tr>
                                  <tr>
                                    <td>Dispatch Within:</td>
                                    <td>{data.load_within ? data.load_within + " Days" : "0 Days"}</td>
                                  </tr>
                                  {data.credit_days > 0 && (
                                    <tr>
                                      <td>Credit Days:</td>
                                      <td>
                                        {data.credit_days} Days
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                              <p className="price-note border-bottom text-bill pb-1 mb-1">
                                {data.credit_days > 0 && (
                                  <>
                                    Dispatch Within agreed days, else seller may cancel or dispatch at their choice
                                  </>
                                )}
                              </p>
                              {(data.orderData.freight > 0 || data.orderData.total_freight > 0) && (
                                <>
                                  <table>
                                    <tbody>
                                      <tr>
                                        <td>Freight:</td>
                                        <td>
                                          Rs{" "}
                                          <NumberFormatter
                                            number={data.orderData.freight}
                                          />
                                          /MT
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          Total Freight
                                          <small>(Freight * Total Quantity)</small>:
                                        </td>
                                        <td>
                                          Rs{" "}
                                          <NumberFormatter
                                            number={data.orderData.total_freight}
                                          />{" "}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <p className="price-note border-bottom text-bill pb-1 mb-1">
                                    {" "}
                                    Freight may change +/- 100. (Freight depends on
                                    demand & supply of trucks on loading day)
                                  </p>
                                </>
                              )}
                              <table>
                                <tbody>
                                  <tr>
                                    <td>
                                      Total Amount Payable
                                      {data.orderData.freight > 0 || data.orderData.total_freight > 0 ? (
                                        <small> (Ex-Factory + Freight)</small>
                                      ) : (
                                        <small> (Ex-Factory)</small>
                                      )}:
                                    </td>
                                    <td>
                                      Rs{" "}
                                      <NumberFormatter
                                        number={
                                          data.orderData.total_payable_amount
                                        }
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <p className="price-note text-bill">
                                {" "}
                                Disclaimer: The invoice amount will be updated
                                after the goods are loaded and the final quantity
                                is confirmed.
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-6 px-2">
                            <div className="purchase-order-table">
                              <label className="order-label">
                                Estimate Price
                              </label>
                              <div className="table-responsive">
                                <table className="table chart-table table-bordered m-0">
                                  <thead>
                                    <tr>
                                      <th scope="col">Requirements</th>
                                      <th scope="col">Ex Price</th>
                                      <th scope="col">Ex Price x Qty</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {data.variation.map((item) => {
                                      return (
                                        <tr key={item.id}>
                                          <td className="fw-normal">
                                            {" "}
                                            {item.value[0].value}
                                            {item.value[0].unit.short_name}
                                            {" - "}
                                            {item.quantity}MT
                                          </td>
                                          <td>
                                            Rs{" "}
                                            <NumberFormatter
                                              number={item.per_unit_price}
                                            />
                                            /MT
                                          </td>
                                          <td>
                                            Rs{" "}
                                            <NumberFormatter
                                              number={item.final_price}
                                            />
                                          </td>
                                        </tr>
                                      );
                                    })}
                                    <tr>
                                      <td colSpan="2" className="text-start fw-bold">
                                        Total Ex Price:
                                      </td>
                                      <td className="fw-bold">
                                        Rs{" "}
                                        <NumberFormatter
                                          number={data.orderData.total_ex_price}
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <p className="price-note">Rate included - loading charges, insurance charges, packaging charges, quality inspection charges &amp; GST.</p>
                                <p className="price-note"> Note - Final invoice will be based on final loaded quantity at booked rates.</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-5 px-2">
                            <div className="purchase-order-table">
                              <label className="order-label">Order Payment</label>
                              {data.status === "ordered" ? (
                                <>
                                  <h6 className="text-success">
                                    {" "}
                                    Your Order Has been Processed
                                  </h6>
                                  {data.product.order_id && (
                                    <div className="mb-2">
                                      <Link
                                        to={`/order-details/${data.product.order_id}`}
                                        className="submit_btn bg-warning"
                                      >
                                        Go to order
                                      </Link>
                                    </div>
                                  )}
                                </>
                              ) : (
                                <p className="price-note mb-1">
                                  {" "}
                                  You have to pay minimum order amount to confirm
                                  this order
                                </p>
                              )}
                              <table className="order-table">
                                <tbody>
                                  
                                  {data.token_amount > 0 ? (
                                    <tr>
                                      <td>
                                        <h6 className="mb-1">Booking Paid Amount:</h6>
                                      </td>
                                      <td>
                                        <h6 className="text-primary mb-1">
                                          Rs{" "}
                                          <NumberFormatter
                                            number={data.token_amount}
                                          />
                                        </h6>
                                      </td>
                                    </tr>
                                  ): (
                                    <tr>
                                      <td>
                                        <h6 className="mb-1">Booking Amount:</h6>
                                      </td>
                                      <td>
                                        <h6 className="text-primary mb-1">
                                          Rs{" "}
                                          <NumberFormatter
                                            number={data.orderData.order_amount}
                                          />
                                        </h6>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div className="col-lg-7 px-2">
                            <div className="purchase-order-table">
                              <label className="order-label">Disclaimer</label>
                              <ol className="list-order-style">
                                <li>This order can not be cancelled.</li>
                                <li>
                                  Advance amount will not be refunded/returned if
                                  confirmed ordered is cancelled.
                                </li>
                                <li>You can not return the goods.</li>
                                <li>
                                  In case of goods are completely different
                                  Biznie's management will decide mode of
                                  reimbursement.
                                </li>
                              </ol>
                            </div>
                          </div>
                        </>
                      )}
                  </div>
                </>
              ) : (
                <NoData />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
